import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalDescription,
  ModalTitle,
} from '../../../../../../design-system/modal/modal';
import { XeroConnectModalContent } from './xero-connect-modal-content';

type XeroConnectModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

export const XeroConnectModal = ({ isOpen, onClose, onContinue }: XeroConnectModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent className="h-max w-[520px] p-7">
        <VisuallyHidden>
          <ModalTitle>Exclude sender</ModalTitle>

          <ModalDescription>Exclude sender</ModalDescription>
        </VisuallyHidden>

        <ModalCloseButton onClick={onClose} aria-label="Close modal" />

        <XeroConnectModalContent onContinue={onContinue} />
      </ModalContent>
    </Modal>
  );
};
